import { Suspense, createSignal, createEffect, createResource, For, Show, onMount, onCleanup } from "solid-js";
//import { GetObjectTaggingCommand } from "@aws-sdk/client-s3";
import { listBucket, S3Object, getAssetHeader } from "~/utils";
import { PortalSearch } from "~/components/PortalSearch";

import "~/_assets/genie-assets.css";

const getAssets = async (): Promise<S3Object[]> => {
	"use server";

	const assets = await listBucket( "_assets/_xsl/" );

	return assets ?? [];
};

const getAssetTags = async ( key: string ): Promise<{}> => {
	"use server";

	const tags = await getAssetHeader( key );

	return tags ?? [];
};


export default function Assets() {
	const [currentGroup, setCurrentGroup] = createSignal<string | undefined>( undefined );
	const [assetGroups, setGroups] = createSignal<string[]>( [] );

	const [visibleAssets, setVisibleAssets] = createSignal( );
	const [assets] = createResource<S3Object[]>( getAssets );

	createEffect( () => assets() && setVisibleAssets( assets()!.filter( asset => asset.Key.split( '/' )[2] === currentGroup() ) ) );

	createEffect( () => {
		if ( !assets() ) return;

		const groups = new Set<string>();

		assets()?.forEach( asset => {
			groups.add( asset.Key.split( '/' )[2] );
		} );

		setCurrentGroup( [...groups][0] );
		setGroups( [...groups] );
	} );

	onMount( () => {
		console.log( "Assets mounted" )

		return () => console.log( "Assets unmounted" );
	} );

	return (
		<>
			<PortalSearch placeholder="Filter" onInput={e => setFilter( e.target.value.toLowerCase() )} />
			
			<div style="font-size:120%;display:flex;justify-content:space-between;">
				<Suspense fallback={<p>Loading asset groups…</p>}>
					<h1 style="margin-right: 2rem;">{assets() ? assets()?.length : '-'} Assets</h1>
				</Suspense>
			</div>

			<div id="genie-assets" class="genie-filter">

				<ul id="asset-groups">
					<Suspense fallback={<li>Loading asset groups…</li>}>
						<For each={assetGroups()}>
							{assetGroup => <li onClick={() => setCurrentGroup( assetGroup )}>{assetGroup.replaceAll( '-', ' ' )}</li>}
						</For>
					</Suspense>
				</ul>

				<Suspense fallback={<p>Loading assets…</p>}>
					<div class="asset-list">
						<Show
							when={visibleAssets()?.length}
							fallback={<p>No assets found.</p>}
						>
							<For each={visibleAssets()}>
								{asset => <AssetItem asset={asset} />}
							</For>
						</Show>
					</div>
				</Suspense>
			</div>
		</>
	)
}



const AssetItem = ( props ) => {
	/*
	const [tags, setTags] = createSignal( {} );
	const [tagResp] = createResource(
		() => s3Client.send(
			new GetObjectTaggingCommand( {
				Bucket: "genie-cloud",
				Key: props.asset.Key!,
			} )
		) );*/

	const [tags] = createResource( props.asset.Key, getAssetTags );

	return (
		<div classList={{ "genie-asset-background": true }}>
			<h2>{props.asset.Key}</h2>

			<Suspense fallback={<p>Tags coming</p>}>
				<Show when={tags} fallback={<p>Get tags</p>}>
					<AssetTags tags={tags()} />
				</Show>
			</Suspense>
		</div>
	)
}

const AssetTags = ( { tags } ) => {
	//const tags = makeObj( tagSet );
	//console.log( "tags", tags )
	return (
		<>
			<h3>Asset Tags</h3>
			{/*
			<h3>
				{tags.AssetName && Buffer.from( tags.AssetName, "base64" ).toString( "utf8" )}
			</h3>
			{tags.Sizes && <p>Sizes: {tags.Sizes.split( "=" ).join( ", " )}</p>}
			{tags.Tags && <p>Tags: {tags.Tags.split( "=" ).join( ", " )}</p>}
			{tags.Supports && <p>Supports: {tags.Supports.split( "=" ).join( ", " )}</p>}
			{tags.Permission && <p>Permission: {tags.Permission}</p>}
			{tags.Approved && <p>Approved: {tags.Approved}</p>}
			{tags.Pages && <p>Page Count: {tags.Pages}</p>}
			 */}
		</>
	);
}

/*
const makeObj = ( set: { Key: string; Value: string }[] ) =>
	set.reduce<Record<string, string>>( ( o, { Key, Value } ) => {
		o[Key] = Value;
		return o;
	}, {} );*/